import React from "react";
import { Tag } from "antd";
import { GeneralLedgerCategories, VatCategories } from "../general-ledgers.js";

export const LedgersColumns = [
    {
        title: 'Code',
        dataIndex: 'code',
        sorter: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: true,
        render: (name, record) => (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                <span>{name}</span>
                {record?.priority && (
                    <Tag
                        color="gold"
                        style={{
                            margin: 0,
                            fontSize: '10px',
                            lineHeight: '16px',
                            padding: '0 6px',
                            borderRadius: '10px',
                            fontWeight: 500,
                            border: '1px solid #ffd591',
                            backgroundColor: '#fff7e6',
                            color: '#d46b08',
                        }}
                    >
                        Priority
                    </Tag>
                )}
            </span>
        ),
    },
    {
        title: 'Category',
        dataIndex: 'category',
        render: cat => GeneralLedgerCategories[cat],
        sorter: true,
    },
    {
        title: 'VAT Category',
        dataIndex: 'vat_category',
        render: cat => VatCategories[cat],
        sorter: true,
    },
    {
        title: 'VAT Type',
        dataIndex: 'vat_type',
        render: vat_type => vat_type?.description,
        sorter: true,
    },
    {
        title: 'Ledger Text',
        dataIndex: 'ledger_text',
        sorter: true,
    },
    {
        title: 'Ledger Text En',
        dataIndex: 'ledger_text_en',
        sorter: true,
    },
    {
        title: 'Entity',
        dataIndex: 'entity',
        render: entity => entity?.name,
        sorter: true,
    },
]